import { render, staticRenderFns } from "./PaymentCart.vue?vue&type=template&id=62b924ca&scoped=true"
import script from "./PaymentCart.vue?vue&type=script&lang=js"
export * from "./PaymentCart.vue?vue&type=script&lang=js"
import style0 from "./PaymentCart.vue?vue&type=style&index=0&id=62b924ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b924ca",
  null
  
)

export default component.exports